import { useCallback, useState } from 'react'
import { RequestStatus } from '@sales-center/common'
import { useActivitySummaryContext } from '../ActivitySummary/context'
import { fetchActivitySummary, fetchTopStats } from '../ActivitySummary/effects'

export function useRefreshActivitySummaryTable() {
  const [
    {
      activeTab,
      filterSet: { normalizedFilters, orderBy, filters },
      tableState: {
        paginationState: { page, pageSize },
      },
    },
    dispatch,
  ] = useActivitySummaryContext()
  const [status, setStatus] = useState<RequestStatus>('idle')

  const refreshActivitySummaryTable = useCallback(async () => {
    setStatus('loading')

    const action = await fetchActivitySummary({
      page,
      orderBy,
      pageSize,
      tab: activeTab,
      normalizedFilters,
    })

    dispatch(action)
    setStatus('idle')
  }, [activeTab, dispatch, normalizedFilters, orderBy, page, pageSize])

  const refetch = useCallback(async () => {
    setStatus('loading')

    const action = await fetchActivitySummary({
      page,
      orderBy,
      pageSize,
      tab: activeTab,
      normalizedFilters,
    })

    dispatch(action)
    const response = await fetchTopStats(filters)
    dispatch(response)
    setStatus('idle')
  }, [activeTab, dispatch, normalizedFilters, orderBy, page, pageSize, filters])

  return { refreshActivitySummaryTable, status, refetch } as const
}
